<div class="flex w-full gap-2">
  <div class="relative flex-1">
    <ui-input
      type="text"
      [value]="quickAddText"
      (valueChange)="onQuickAddInput($event)"
      (keydown.enter)="onEnter()"
      (keydown.arrowdown)="onArrowDown($event)"
      (keydown.arrowup)="onArrowUp($event)"
      (keydown.escape)="onEscape()"
      (focused)="onQuickAddFocus()"
      (blurred)="onQuickAddBlur()"
      placeholder="z.B. 2 Liter Milch, 500g Mehl"
      [clearable]="true"
      (cleared)="clearQuickAdd()"
      [fullWidth]="true"
      ariaLabel="Artikel zur Einkaufsliste hinzufügen"
      class="w-full">
    </ui-input>

    <!-- Autosuggest dropdown -->
    @if (showQuickAddSuggestions) {
      <ul
        role="listbox"
        class="absolute z-50 left-0 right-0 mt-1 max-h-80 overflow-y-auto rounded-box border border-base-200 bg-base-100 shadow-lg p-1">
        @for (s of quickAddSuggestions; track s.key; let i = $index) {
          <li>
            <button
              type="button"
              role="option"
              [attr.aria-selected]="i === activeIndex"
              class="flex items-center gap-2 w-full rounded-lg px-2 py-1.5 text-left hover:bg-base-200 transition-colors"
              [class.bg-base-200]="i === activeIndex"
              (mouseenter)="activeIndex = i"
              (mousedown)="$event.preventDefault()"
              (click)="selectSuggestion(s)">

              <!-- icon -->
              <span class="w-7 h-7 flex items-center justify-center shrink-0">
                @if (s.product_key) {
                  <img
                    [src]="productIconUrl(s.product_key)"
                    [alt]="s.product_key"
                    class="max-w-full max-h-full object-contain"
                    loading="lazy" />
                } @else {
                  <fa-icon [icon]="faCartShopping" class="text-base-content/30"></fa-icon>
                }
              </span>

              <!-- title (subtitles intentionally omitted) -->
              <span class="flex-1 min-w-0 truncate text-sm">{{ s.title }}</span>

              <!-- colorized source badge -->
              <span class="badge badge-sm shrink-0" [ngClass]="suggestionBadgeClass(s.source)">
                {{ suggestionLabel(s.source) }}
              </span>
            </button>
          </li>
        }
      </ul>
    }
  </div>

  <ui-button
    variant="primary"
    [loading]="adding()"
    [disabled]="!quickAddText.trim()"
    (clicked)="quickAdd()">
    <fa-icon [icon]="faPlus"></fa-icon>
  </ui-button>
</div>
